import Vue from 'vue'
import App from './App.vue'
import VueGtag from "vue-gtag";

import "@/assets/scss/main.scss";

Vue.config.productionTip = false

import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.VUE_APP_OLD_SERVER_BASE_URL;
//Vue.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

Vue.prototype.$eventBus = new Vue();

import BDialog from '@/components/Elements/BDialog/Plugin.js'
Vue.use(BDialog);

import {
    VueReCaptcha
} from 'vue-recaptcha-v3'

Vue.use(VueReCaptcha, {
    siteKey: process.env.VUE_APP_RECAPTCHA_CLIENT_V3
})


import VueRouter from 'vue-router';
import PageVideoShareIndex4 from '@/components/Pages/PageVideoShareIndex4.vue';
Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    base: '/VideoShare/',
    routes: [
        {
            path: '/Index4/:vsId',  // Material/Study
            component: PageVideoShareIndex4,
            props: true,
        },
    ]
});

Vue.use(VueGtag, {
    config: {
        id: "UA-136510434-1"
    },
    includes: [{
        id: 'AW-608742370'
    },]
}, router);

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const messages = {
    'zh-Hant': {
        element_header: require('@/locales/element_header_zh-hant.json'),
        element_footer: require('@/locales/element_footer_zh-hant.json'),
        page_material_study: require('@/locales/page_material_study_zh-hant.json'),
        element_video_caption_list: require('@/locales/element_video_caption_list_zh-hant.json'),
        element_b_dialog: require('@/locales/element_b_dialog_zh-hant.json'),
    },
    'zh-Hans': {
        element_header: require('@/locales/element_header_zh-hans.json'),
        element_footer: require('@/locales/element_footer_zh-hans.json'),
        page_material_study: require('@/locales/page_material_study_zh-hans.json'),
        element_video_caption_list: require('@/locales/element_video_caption_list_zh-hans.json'),
        element_b_dialog: require('@/locales/element_b_dialog_zh-hans.json'),
    },
    'vi-VN': {
        element_header: require('@/locales/element_header_vi-VN.json'),
        element_footer: require('@/locales/element_footer_vi-VN.json'),
        page_material_study: require('@/locales/page_material_study_vi-VN.json'),
        element_video_caption_list: require('@/locales/element_video_caption_list_vi-VN.json'),
        element_b_dialog: require('@/locales/element_b_dialog_vi-VN.json'),
    },
};

const i18n = new VueI18n({
    locale: 'zh-Hant', // set locale
    messages, // set locale messages
});

//then put this into your main.js file anywhere AFTER loading Vue
import VueMeta from 'vue-meta'
Vue.use(VueMeta)

new Vue({
    i18n,
    router,
    render: h => h(App),
}).$mount('#app')


